import React, { useState, useEffect } from "react";
import axios from "axios";
import { Save, Download } from "lucide-react";
import "./PromptEditor.css";

const PromptEditor: React.FC = () => {
    const [text, setText] = useState("");
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const fetchPrompt = async () => {
            setLoading(true);
            try {
                const res = await axios.get("/prompt");
                setText(res.data ?? "");
            } catch (err) {
                console.error("Failed to load prompt", err);
            } finally {
                setLoading(false);
            }
        };

        fetchPrompt();
    }, []);

    const updatePrompt = async () => {
        setSaving(true);
        try {
            await axios.post("/prompt/update", { text });
            alert("Prompt updated.");
        } catch (err) {
            console.error("Failed to update prompt", err);
            alert("Error updating prompt.");
        } finally {
            setSaving(false);
        }
    };

    const downloadLogs = async () => {
        try {
            const res = await axios.get("/logs", {
                responseType: "blob",
            });

            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "alpacatrader_log.txt");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            console.error("Failed to download logs", err);
            alert("Error downloading logs.");
        }
    };

    return (
        <div style={{ maxWidth: "800px", margin: "2rem auto", padding: "1rem" }}>
            <h2>Prompt Editor</h2>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <>
                    <textarea
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        rows={20}
                        style={{ width: "100%", padding: "1rem", fontSize: "1rem" }}
                        className="accountModal-textarea"
                    />
                    <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
                        <button
                            className="accountModal-save-button"
                            onClick={updatePrompt}
                            disabled={saving}
                            aria-label="Save"
                        >
                            <Save size={18} />
                            <span>{saving ? "Saving..." : "Save"}</span>
                        </button>
                        <button
                            className="accountModal-save-button"
                            onClick={downloadLogs}
                            aria-label="Download Logs"
                        >
                            <Download size={18} />
                            <span>Download Logs</span>
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default PromptEditor;
